import { IconName } from '@usealloy/component-library';

export const ENTITY_TYPES = {
  PERSON: 'person',
  BUSINESS: 'business',
  GROUP: 'group',
  ENTITY_GROUP: 'entity-group',
} as const;

export type EntityType = (typeof ENTITY_TYPES)[keyof typeof ENTITY_TYPES];

export const ENTITY_ICON_MAP: Record<EntityType, IconName> = {
  [ENTITY_TYPES.PERSON]: IconName.Person,
  [ENTITY_TYPES.BUSINESS]: IconName.Business,
  [ENTITY_TYPES.GROUP]: IconName.Group,
  [ENTITY_TYPES.ENTITY_GROUP]: IconName.CustomGroup,
};

